<template>
  <CarouselWidget
    class="slide-show-section"
    :items="items"
    :itemsToShow="{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }"
    :gap="0"
    :play-speed="6000"
    nav
    nav-inside
    dark
  >
    <template #item="{ item }">
      <router-link
        :to="parseTo(item)"
        class="slide-show-section_item position-relative"
      >
        <img loading="lazy" :src="parseImg(item.img)" />
        <div v-if="item.title" class="slide-show-section_title">
          <a class="text-decoration-none white--text text-h6 text-sm-h4">
            <span class="font-weight-medium">
              {{ item.title }}
            </span>
          </a>
        </div>
      </router-link>
    </template>
  </CarouselWidget>
</template>

<script>
import { formatToURL } from "../../utils/formatToURL";
import CarouselWidget from "../widgets/CarouselWidget/Index.vue";

export default {
  props: {
    items: {
      type: Array,
      required: true,
      validator: (val) => val.length > 0,
    },
  },
  data: () => ({
    imgWidth: null,
  }),
  methods: {
    parseImg(img) {
      if (!img) {
        return `https://placehold.co/1920x1080/777777/FFFFFF/png`;
      }

      return `${this.files}${img}?resize=1&w=${this.imgWidth}`;
    },
    parseTo(item) {
      return "/coberturas/" + formatToURL(item.title) + "-" + item.id;
    },
    setWidth() {
      switch (this.$vuetify.breakpoint.name) {
        case "xl":
        case "lg":
          this.imgWidth = 1920;
          break;
        case "md":
        case "sm":
          this.imgWidth = 1300;
          break;
        default:
          this.imgWidth = 600;
      }
    },
  },
  mounted() {
    this.setWidth();
  },
  components: {
    CarouselWidget,
  },
};
</script>

<style lang="scss">
.slide-show-section {
  &_item {
    display: flex;
    width: 100vw;
    aspect-ratio: 3 / 2;

    img {
      height: 100%;
      width: 100%;
      object-fit: cover;
    }

    &::before {
      content: "";
      position: absolute;
      z-index: 8;
      top: 0;
      left: 0;

      width: 100%;
      height: 100%;
      background: linear-gradient(rgba(0, 0, 0, 0) 50%, #000000 100%);
    }

    &::after {
      content: "";
      position: absolute;
      z-index: 9;
      left: 0;
      bottom: 0;

      width: 100%;
      height: 28vh;
      background: url("../../assets/img/slider-divider.png");
      background-size: cover;
    }
  }

  &_title {
    position: absolute;
    z-index: 10;
    left: 0;
    bottom: 20vh;

    width: 100%;
    display: flex;
    justify-content: center;

    a {
      display: flex;
      text-align: center;
      max-width: 600px;
      transition: 0.2s;

      &:hover {
        transform: scale(1.2);
        filter: drop-shadow(0 0 10px rgba(0, 0, 0, 0.5));
      }
    }
  }
}
@media screen and (max-width: 960px) {
  .slide-show-section {
    &_item {
      &::before {
        background: linear-gradient(rgba(0, 0, 0, 0) 60%, #000000 100%);
      }

      &::after {
        height: 16vw;
      }
    }

    &_title {
      bottom: 12vw;
    }
  }
}
</style>
